"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandSnippetsInText = expandSnippetsInText;
const fs = __importStar(require("fs"));
const path = __importStar(require("path"));
const preprocessor_1 = require("../types/preprocessor");
/** Default file extension for snippet files */
const SNIPPET_EXT = '.txt';
/** Maximum expansion depth to prevent runaway recursion */
const MAX_SNIPPET_DEPTH = 32;
/** Regex to match <snippet:name> - name is lowercase alphanumeric, hyphen, underscore */
const SNIPPET_TAG_REGEX = /<snippet:([a-z0-9_-]+)>/gi;
/**
 * Expands <snippet:name> tags only inside triple-quoted ("\"\"\"...\"\"\"") content.
 * Snippet files are resolved: adventureDirectory/snippets/name.txt then snippetsRoot/name.txt.
 * Supports nested snippets with cycle detection.
 */
function expandSnippetsInText(text, config) {
    const snippetsRoot = config.snippetsRoot;
    const adventureDirectory = config.adventureDirectory;
    if (!snippetsRoot && !adventureDirectory) {
        return text;
    }
    const parts = splitTripleQuotedContent(text);
    for (let i = 1; i < parts.length; i += 2) {
        parts[i] = expandSnippetsInBlock(parts[i], config, [], 0);
    }
    return parts.join('"""');
}
/**
 * Split text by """ so that odd-indexed elements are the content inside triple-quoted blocks.
 * Even-indexed (including 0) are outside (prefix, between blocks, suffix).
 */
function splitTripleQuotedContent(text) {
    const parts = [];
    let remaining = text;
    while (remaining.length > 0) {
        const idx = remaining.indexOf('"""');
        if (idx === -1) {
            parts.push(remaining);
            break;
        }
        parts.push(remaining.slice(0, idx));
        remaining = remaining.slice(idx + 3);
        const endIdx = remaining.indexOf('"""');
        if (endIdx === -1) {
            parts.push(remaining);
            break;
        }
        parts.push(remaining.slice(0, endIdx));
        remaining = remaining.slice(endIdx + 3);
    }
    return parts;
}
function expandSnippetsInBlock(block, config, stack, depth) {
    if (depth > MAX_SNIPPET_DEPTH) {
        throw new preprocessor_1.CircularSnippetError([...stack, '(max depth exceeded)']);
    }
    let result = block;
    for (;;) {
        const match = SNIPPET_TAG_REGEX.exec(result);
        SNIPPET_TAG_REGEX.lastIndex = 0;
        if (!match)
            break;
        const name = match[1];
        const fullMatch = match[0];
        if (stack.includes(name)) {
            throw new preprocessor_1.CircularSnippetError([...stack, name]);
        }
        const content = loadSnippet(name, config);
        const expanded = expandSnippetsInBlock(content, config, [...stack, name], depth + 1);
        result = result.replace(fullMatch, expanded);
    }
    return result;
}
function loadSnippet(name, config) {
    const fileName = name + SNIPPET_EXT;
    const checkedPaths = [];
    if (config.adventureDirectory) {
        const adventureSnippetsDir = path.join(config.adventureDirectory, 'snippets');
        const adventurePath = path.join(adventureSnippetsDir, fileName);
        checkedPaths.push(adventurePath);
        if (fs.existsSync(adventurePath) && fs.statSync(adventurePath).isFile()) {
            return trimSnippetContent(fs.readFileSync(adventurePath, 'utf-8'));
        }
    }
    if (config.snippetsRoot) {
        const globalPath = path.join(config.snippetsRoot, fileName);
        checkedPaths.push(globalPath);
        if (fs.existsSync(globalPath) && fs.statSync(globalPath).isFile()) {
            return trimSnippetContent(fs.readFileSync(globalPath, 'utf-8'));
        }
    }
    throw new preprocessor_1.SnippetNotFoundError(name, checkedPaths);
}
function trimSnippetContent(content) {
    return content.replace(/^\s*\n/, '').replace(/\n\s*$/, '');
}
//# sourceMappingURL=SnippetExpander.js.map